<template>
  <div>
    <pre><code>{{component.html}}</code></pre>
  </div>
</template>

<script>
export default {
  props: ['component'],
}
</script>
